import type { ComponentOverride } from '../types';

export const MuiFormHelperText: ComponentOverride<'MuiFormHelperText'> = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        margin: '8px 12px 0 12px',
      },
    },
  },
};
